const authentication = {
    isAuth: false,
};

export default authentication;
